import React from 'react'
import { Context } from './Context'

/**
 *
 */
export const Provider = ({ value, children }) => {
  return <Context.Provider value={{ ...value }}>{children}</Context.Provider>
}
